import { Component, OnInit } from '@angular/core';
import { CandidateService } from '../candidate.service';
import { CandidateData } from '../candidateData';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/shared.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  candidateData: CandidateData;
  firstName: string;
  lastName: string;

  constructor(private candidateService: CandidateService, private auth: AuthService, private router: Router, private sharedService: SharedService) { }

  ngOnInit() {
    this.auth.getUserId().subscribe(
      (a) => {
        this.candidateService.getCandidateDetails(a.uid).subscribe(
          (a: CandidateData) => {
            this.candidateData = a;
            this.candidateService.candidateData = a;
            console.log(a)
            this.sharedService.updatedisplayName(a.profile.first_name)
            if (this.checkProfileInCompletion(a)) {
              this.router.navigateByUrl('dashboard/edit-profile')
            }
          }
        )
      }
    )
  }

  checkProfileInCompletion(a) {
    localStorage.removeItem("landing")
    if (this.checkIncompleteBasic(a) || this.checkIncompleteSkills(a) || this.checkIncompleteWorkAndEducation(a) || this.checkIncompletePreferences(a) || this.checkIncompleteProfileLinks(a)) {
      return true
    } else {
      return false
    }
  }


  checkIncompleteBasic(data) {
    if (data) {
      // check for profile details start
      if (data.profile) {
        if (!data.profile.mobile || !data.profile.first_name || !data.profile.last_name || !data.profile.address) {
          localStorage.setItem("landing", "BASIC")
          return true
        }
      } else {
        localStorage.setItem("landing", "BASIC")
        return true
      }
      // check for profile details ends
      // check for resume details start
      if (data.resume) {
        if (!data.resume.headline || data.resume.interest == null) {
          localStorage.setItem("landing", "BASIC")
          return true
        }
      } else {
        localStorage.setItem("landing", "SKILLS")
        return true
      }
      // check for resume details ends
    }
  }


  checkIncompleteSkills(data) {
    // check for skills start
    if (data.resume.skills) {
      if (!data.resume.skills.additionalSkills || data.resume.skills.additionalSkills.length == 0 || !data.resume.skills.primarySkills || data.resume.skills.primarySkills.length == 0) {
        localStorage.setItem("landing", "SKILLS")
        return true
      } else {
        // check for job types start
        if (data.resume.job_type) {
          if (!data.resume.job_type.name || !data.resume.job_type.total_experience) {
            localStorage.setItem("landing", "SKILLS")
            return true
          } else {
            // check for job roles start
            if (data.resume.job_roles) {
              if (data.resume.job_roles.length == 0) {
                localStorage.setItem("landing", "SKILLS")
                return true
              }
            } else {
              localStorage.setItem("landing", "SKILLS")
              return true
            }
            // check for job roles ends
          }
        } else {
          localStorage.setItem("landing", "SKILLS")
          return true
        }
        // check for job types ends
      }
    } else {
      localStorage.setItem("landing", "SKILLS")
      return true
    }
    // check for skills ends
  }


  checkIncompleteWorkAndEducation(data) {
    // check for work experiences start
    if (data.resume.work_experience) {
      if (data.resume.work_experience.length == 0) {
        localStorage.setItem("landing", "WORK")
        return true
      } else {
        // check for education deatils start
        if (data.resume.education_details) {
          if (data.resume.education_details.length == 0) {
            localStorage.setItem("landing", "EDUCATION")
            return true
          }
        } else {
          localStorage.setItem("landing", "EDUCATION")
          return true
        }
        // check for education deatils ends
      }
    } else {
      localStorage.setItem("landing", "WORK")
      return true
    }
    // check for work experiences ends
  }


  checkIncompletePreferences(data) {
    // check for preferences start
    if (data.resume.preferences) {
      if (data.resume.preferences.any_state_in_usa == null) {
        localStorage.setItem("landing", "PREFERENCES")
        return true
      }
      if (!data.resume.preferences.employement_types.full_time.selected && !data.resume.preferences.employement_types.contractor.selected && !data.resume.preferences.employement_types.internship.selected) {
        localStorage.setItem("landing", "PREFERENCES")
        return true
      }
    }
    else {
      localStorage.setItem("landing", "PREFERENCES")
      return true
    }
    // check for preferences ends
  }


  checkIncompleteProfileLinks(data) {
    // check for profile urls start
    if (data.resume.githubUrl == "" || data.resume.linkedinUrl == "") {
      localStorage.setItem("landing", "PROFILE")
      return true
    }
    // check for profile urls ends
  }


}
